import { render, staticRenderFns } from "./DeliveryTable.vue?vue&type=template&id=f86eea2e&scoped=true"
import script from "./DeliveryTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliveryTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DeliveryTable.vue?vue&type=style&index=0&id=f86eea2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86eea2e",
  null
  
)

export default component.exports